(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lurve-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lurve-shop-look')) {
    customElements.define('lurve-shop-look', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        this.points = [...this.querySelectorAll('[data-look-target]')];
        this.items = [...this.querySelectorAll('.lurve-look__item')];
        this.points.forEach(point => this.querySelector('.lurve-look__photo').append(point));
        if (!this.points.length) return;
        this.select = (id) => {
          this.items.forEach(item => { item.hidden = item.id !== id; });
          this.points.forEach(point => point.setAttribute('aria-pressed', String(point.dataset.lookTarget === id)));
        };
        this.addEventListener('click', event => {
          const point = event.target.closest('[data-look-target]');
          if (point) this.select(point.dataset.lookTarget);
        });
        this.addEventListener('keydown', event => {
          const index = this.points.indexOf(event.target);
          if (index < 0 || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const delta = ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1;
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.points.length - 1 : (index + delta + this.points.length) % this.points.length;
          this.points[next].focus();
          this.select(this.points[next].dataset.lookTarget);
        });
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('.lurve-look__item');
          if (item) this.select(item.id);
        });
        this.select(this.points[0].dataset.lookTarget);
        this.setAttribute('data-ready', '');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
